// Indexed by dynamic country/province codes from live dispensary/user data
// (see packages/shared/helpers/age-restrictions.js), so country and province
// keys stay plain string index signatures rather than literal unions —
// narrowing them would force a cast at those lookup sites rather than catch
// a real bug.
type RegionAgeRestrictions = {
  [subRegionCode: string]: number;
  default: number;
};

type AgeRestrictionsByCountry = {
  [countryCode: string]: RegionAgeRestrictions | number;
  default: number;
};

// country -> state/province code
export const ageRestrictions: AgeRestrictionsByCountry = {
  default: 21,
  US: {
    default: 21,
  },
  CA: {
    default: 21,
    AB: 18, // Alberta
    BC: 19, // British Columbia
    MB: 19, // Manitoba
    NB: 19, // New Brunswick
    NL: 19, // Newfoundland and Labrador
    NT: 19, // Northwest Territories
    NS: 19, // Nova Scotia
    NU: 19, // Nunavut
    ON: 19, // Ontario
    PE: 19, // Prince Edward Island
    QC: 21, // Quebec
    SK: 19, // Saskatchewan
    YT: 19, // Yukon
  },
};
